module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-monitor-0fad6929eab5ee08c14fa6a8429c0e7f.png";